<template>
  <div ref="accent">
    <TreeMenuItemAccent v-if="shouldRender" />
  </div>
</template>
<script setup lang="ts">
import type { WorkflowOverviewItemType } from '@app/application/workflow-overview-navigation/types'

import { computed, ref, watchEffect } from 'vue'

import TreeMenuItemAccent from '@app/shared/vue/components/menu/tree/tree-menu-accent.vue'

import { useCurrentHighlightedItem } from '../composables/use-current-highlighted-item'

interface Props {
  itemId: number
  itemType: WorkflowOverviewItemType
  highlightedId?: number
  highlightedType?: WorkflowOverviewItemType
  scrollIntoViewTimestamp?: number
}

const props = withDefaults(defineProps<Props>(), {
  scrollIntoViewTimestamp: 0,
})

const emit =
  defineEmits<{
    scrollOffsetElement: [value: HTMLElement]
  }>()

const accent = ref<HTMLElement | null>(null)

const { currentId, currentItemClass } = useCurrentHighlightedItem(
  () => props.highlightedId,
  () => props.highlightedType
)

const shouldRender = computed(() => {
  return (
    props.itemId === currentId.value &&
    props.itemType === currentItemClass.value
  )
})

watchEffect(() => {
  if (shouldRender.value && accent.value && props.scrollIntoViewTimestamp) {
    emit('scrollOffsetElement', accent.value)
  }
})
</script>
